import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const ToggleElementStyled = styled(FlexWrapper) `
  box-sizing: border-box;
  border: 1px solid ${colorCoreGray500};
  position: relative;
  border-radius: ${CORNER_RADIUS.s};
  padding: 12px 16px;
  height: 44px;
  user-select: none;
`;
